import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Auth0Provider } from "@auth0/auth0-react";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={ "dev-tk662yie3thewmwp.us.auth0.com" }
      clientId={ "0HfTzPIMcpbdrp7vmOKYcgwy1fZKQNkA" }
      cacheLocation="localstorage"
      authorizationParams={ {
        redirect_uri: window.location.origin
      } }
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);
